<template>
    <div class="m-promotionSlider" @mouseleave="sliderMouseLeave">
        <div class="m-promotionSlider__wrapper">
            <button
                class="btn btn-custom-gray btn-slider slider-prev m-promotionSlider__btn"
                data-slider-prev
                aria-controls="tns1"
                tabindex="-1"
                data-controls="prev"
                @click="prevSlide"
                :disabled="activeSlideIndex === 0"
            >
                <a-icon icon="ArrowLeft" width="24px" />
            </button>
            <button
                class="btn btn-custom-gray btn-slider slider-next m-promotionSlider__btn"
                data-slider-next
                aria-controls="tns1"
                tabindex="-1"
                data-controls="next"
                @click="nextSlide"
                :disabled="activeSlideIndex + items >= slideCount"
            >
                <a-icon icon="ArrowRight" width="24px" />
            </button>

            <tiny-slider
                class="m-promotionSlider__slider"
                :ref="'attachmentsSlider'"
                v-bind="tinySliderOptions"
                @indexChanged="slideChanged"
            >
                <div
                    class="m-promotionSlider__slide promo-details-slide"
                    v-for="slide in data"
                    :key="slide.id"
                >
                    <a
                        download
                        class="m-promotionSlider__slide"
                        :href="slide.urls.original"
                        style="overflow: hidden"
                        @click.prevent="
                            clickFile(
                                slide.urls.original,
                                slide.fileName,
                                $event,
                                slide.id
                            )
                        "
                        :class="{
                            '--hover': isImgOrPdf(slide)
                        }"
                        @mouseenter="hoverFile(true, $event, isImgOrPdf(slide))"
                        @mouseleave="
                            hoverFile(false, $event, isImgOrPdf(slide))
                        "
                    >
                        <figure
                            class="m-promotionSlider__figure embed-responsive"
                        >
                            <div class="m-promotionSlider__iconWrapper">
                                <template
                                    v-if="
                                        slide.urls.original.includes('pdf') ||
                                            slide.fileName.includes('pdf')
                                    "
                                >
                                    <vue-pdf
                                        style="
                                        width: auto;
                                        height: auto;
                                        max-width: 95%;
                                        max-height: 100%;
                                    "
                                        :src="slide.urls.original"
                                    />
                                </template>
                                <template v-else-if="isImg(slide)">
                                    <img
                                        :src="slide.urls.original"
                                        class="img-fluid"
                                    />
                                </template>
                                <template v-else>
                                    <a-icon
                                        width="64px"
                                        height="64px"
                                        :icon="iconType(slide.urls.original)"
                                    />
                                </template>
                            </div>
                        </figure>
                        <p
                            class="m-promotionSlider__slideName text-primary text-sm"
                        >
                            {{ slide.name }}
                        </p>
                    </a>
                    <the-btn
                        v-if="showDownloadBtn"
                        class="m-promotionSlider__downloadBtn btn-custom-gray px-3"
                        @click.native="
                            downloadFile(
                                slide.urls.original,
                                slide.fileName,
                                slide.id
                            )
                        "
                    >
                        <a-icon v-if="!isLoading(slide.id)" icon="Download" />
                        <button-spinner v-else :status="'loading'" />
                    </the-btn>
                </div>
            </tiny-slider>
        </div>
    </div>
</template>

<script>
import VueTinySlider from 'vue-tiny-slider'
import VuePdf from 'vue-pdf'

export default {
    props: {
        data: {
            type: Array,
            required: true
        },
        showDownloadBtn: {
            type: Boolean,
            default: false
        },
        responsive: {
            type: Object,
            default: () => {
                return {
                    320: {
                        items: 2
                    },
                    520: {
                        items: 3
                    },
                    768: {
                        items: 3
                    },
                    992: {
                        items: 2
                    }
                }
            }
        }
    },
    data() {
        return {
            tinySliderOptions: {
                items: 3,
                slideBy: 1,
                autoplay: false,
                mouseDrag: true,
                gutter: 10,
                edgePadding: 0,
                autoplayButtonOutput: false,
                controls: false,
                nav: false,
                loop: false,
                responsive: this.responsive
            },
            activeSlideIndex: 0,
            slideCount: 0,
            items: 0,
            imgFormats: ['jpg', 'png', 'jpeg'],
            defaultMarginBottom: 30
        }
    },
    components: {
        TinySlider: VueTinySlider,
        VuePdf
    },
    methods: {
        prevSlide() {
            this.$refs.attachmentsSlider.slider.goTo('prev')
        },
        nextSlide() {
            this.$refs.attachmentsSlider.slider.goTo('next')
        },
        iconType(str) {
            const XlsTypes = ['xls', 'xlsx']
            const DocTypes = ['doc', 'docx']
            const ZipTypes = ['zip', 'zipx']
            if (XlsTypes.some(v => str.includes(v))) {
                return 'Xls'
            } else if (DocTypes.some(v => str.includes(v))) {
                return 'Doc'
            } else if (ZipTypes.some(v => str.includes(v))) {
                return 'Zip'
            } else {
                return 'Download'
            }
        },
        slideChanged() {
            this.updateSliderInfo()
        },
        updateSliderInfo() {
            const sliderInfo = this.$refs.attachmentsSlider.slider.getInfo()
            this.slideCount = sliderInfo.slideCount
            this.activeSlideIndex = sliderInfo.index
            this.items = sliderInfo.items
        },
        hoverFile(hover, elem, isImgOrPdf) {
            elem.stopPropagation()
            elem.preventDefault()
            const slider = this.$el
            const slideElem = elem.target.closest('.m-promotionSlider__slide')
            if (this.deviceType === 'desktop') {
                if (hover) {
                    slideElem.classList.add('--active')
                    if (isImgOrPdf) {
                        slider.classList.add('--hoverImgOrPdf')
                    }
                    const slideNameHeight = elem.target.querySelector(
                        '.m-promotionSlider__slideName'
                    ).clientHeight
                    if (slideNameHeight > this.defaultMarginBottom) {
                        slider.style.marginBottom = `${slideNameHeight}px`
                    }
                } else {
                    slideElem.classList.remove('--active')
                    slider.style.marginBottom = `${this.defaultMarginBottom}px`
                }
            }
        },
        sliderMouseLeave() {
            if (this.$el.classList.contains('--hoverImgOrPdf')) {
                this.$el.classList.remove('--hoverImgOrPdf')
            }
        },
        clickFile(src, fileName, elem, slideId) {
            elem.stopPropagation()
            elem.preventDefault()
            const slideElem = elem.target.closest('.m-promotionSlider__slide')
            const isPdf = slideElem.classList.contains('--hover')
            if (
                this.deviceType === 'desktop' &&
                slideElem.classList.contains('--active')
            ) {
                this.downloadFile(src, fileName, slideId)
            }

            if (this.deviceType === 'mobile') {
                document
                    .querySelectorAll('.m-promotionSlider__slide.--active')
                    .forEach(el => {
                        if (el !== slideElem) {
                            el.classList.remove('--active')
                        }
                    })
                if (isPdf) {
                    slideElem.classList.add('--active')
                    this.downloadFile(src, fileName, slideId)
                } else {
                    this.downloadFile(src, fileName, slideId)
                }
            }
        },
        isImg(slide) {
            if (slide.fileName) {
                return this.imgFormats.some(v => slide.fileName.includes(v))
            } else {
                return (
                    slide.urls.original.includes('pdf') ||
                    this.imgFormats.some(v => slide.urls.original.includes(v))
                )
            }
        },
        isImgOrPdf(slide) {
            return slide.fileName.includes('pdf') || this.isImg(slide)
        },
        hasImgOrPdf() {
            return this.data.some(el => {
                return el.fileName.includes('pdf') || this.isImg(el)
            })
        },
        async downloadFile(src, fileName, slideId) {
            this.$store.dispatch('setDownloadFileStatus', {
                status: 'loading',
                fileId: slideId
            })
            await this.$functions.downloadFile(src, fileName)
            setTimeout(() => {
                this.$store.dispatch('setDownloadFileStatus', {
                    status: 'idle',
                    fileId: slideId
                })
            }, 500)
        },
        isLoading(slideId) {
            return (
                this.$store.getters.getDownloadFileStatus.status ===
                    'loading' &&
                this.$store.getters.getDownloadFileStatus.fileId === slideId
            )
        }
    },
    computed: {
        deviceType() {
            return this.$store.getters.getUserDeviceType
        }
    },
    mounted() {
        this.updateSliderInfo()
        document.addEventListener('click', elem => {
            document
                .querySelectorAll('.m-promotionSlider__slide.--active')
                .forEach(el => {
                    if (
                        !elem.target.classList.contains('temp-slide-download')
                    ) {
                        el.classList.remove('--active')
                    }
                })
        })
        const slider = this.$el
        const sliderHeight = slider.clientHeight
        const wrapperHeight = slider.firstElementChild.clientHeight
        this.defaultMarginBottom = wrapperHeight - sliderHeight

        slider.style.marginBottom = `${this.defaultMarginBottom}px`
    },
    beforeMount() {
        HTMLCanvasElement.prototype.getContext = (function (original) {
            return function (type, options) {
                if (type === '2d') {
                    options = { ...options, willReadFrequently: true }
                }
                return original.call(this, type, options)
            }
        })(HTMLCanvasElement.prototype.getContext)
    }
}
</script>
